module.exports = __webpack_public_path__ + "img/ultraGPT.72176c94.png";